export default function useNumberFormatting(value, digits) {
  let number = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
  return { number };
}
